import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Container, Row, Col, Modal, Label, Button, Input } from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import moment from 'moment';
import { CopyToClipboard } from "react-copy-to-clipboard";
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import i18next from 'i18next';
import USDT from "./usdt";
import {  Typography } from "@material-ui/core";
import ReactApexChart from "react-apexcharts";
import { FormFeedback } from "reactstrap";
import christmastree from "../../assets/images/christmas-tree.png";
import underline from "../../assets/images/underline.png";

const series1 = [  { data: [0, 15, 20, 22, 30, 40, 50, 60, 70, 80, 100] }, ]
const series2 = [  { data: [0, 25, 26, 28, 35, 50, 80, 60, 50, 70, 100] }, ]

const options1 = {
  chart: { sparkline: { enabled: !0 } },
  stroke: { curve: "smooth", width: 2 },
  colors: ["#036B41"],
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      inverseColors: !1,
      opacityFrom: 0.45,
      opacityTo: 0.5,
      stops: [25, 100, 100, 100],
    },
  },
  tooltip: { enabled: false }, 
}

const Dashboard = props => {
  const history = useHistory();
  //meta title
  document.title = i18next.t('Dashboard PG document title');
	const location = useLocation();
  const { getRequest, postRequest, getRequestForBinance } = useRequests();

  // Gift Card Redeem Modal State
  const [redeemModal, setRedeemModal] = useState(false);
  const [giftCardCode, setGiftCardCode] = useState("");
  const [giftCardTouched, setGiftCardTouched] = useState(false);
  const [redeemLoading, setRedeemLoading] = useState(false);

  const handleRedeemGiftCard = async () => {
    setGiftCardTouched(true);
    if (!giftCardCode) return;
    setRedeemLoading(true);
    const jsonpar = JSON.stringify({ code: giftCardCode });
    const res = await postRequest("redeem-gift-card", jsonpar);
    if (res && res.code === 200) {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'success',
        message: res.message,
      }));
      handleLoadGetUserInfo();
      setRedeemModal(false);
      setGiftCardCode("");
      setGiftCardTouched(false);
    } else {
      setAlertData({ variant: "error", message: res.message || "Redemption failed" });
    }
    // setGiftCardCode("");
    // setGiftCardTouched(false);
    setRedeemLoading(false);
    resetAlertData();
  };


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const [Transaction, setTransaction] = React.useState([]);
  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    setTransaction(elementData);
    setStandardModal1(true);
  }

  const [ ReferralLink, setReferralLink ] = React.useState('');
  const [ collaborator, setCollaborator ] = React.useState('false');
  const handleLoadGetUserInfo = async () => {
    const res = await getRequest('get-user-info');
    if (res && res.code === 200) {
      let originalText = res.data;

      setReferralLink(process.env.REACT_APP_SITE_URL+'register/'+originalText.referral_code);
      if(originalText.collaborator_referral_code){
        setCollaborator('true');
      }
    }
    // ...existing code...
  }

  const [FilePath, setFilePath] = React.useState('');
  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.pct_id}</td>
        <td>{element.token}</td>
        <td>{element.currency}</td>
        <td>{parseFloat(element.received_amount)} &nbsp;{element.currency}</td>
        <td>{moment(element.created_at).format('YYYY-MM-DD | HH:mm')}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Pending' ? 'badge-soft-warning' : element.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span></td>
        <td className="text-center"><button type="button" className="btn-sm btn btn-primary" onClick={(e)=>togStandardModal1(element)}><i className="mdi mdi-eye"></i></button></td>
      </tr>
    ));

    setTransactionTBody(tempTBody);
  }
  
  const [ allProperyInvestment, setAllProperyInvestment ] = React.useState('');
  const handlePropertyInvestmentBody = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td><Link to={`/property-details/`+ btoa(element.property_id)} >{element.property_name}</Link></td>
        <td style={{ width: "200px", textAlign: "center"}}>{element.TotalValue}</td>
        <td style={{ width: "200px"}}>{element.TotalValueTokenPrice} €</td> 
        <td style={{ width: "200px"}}>{element.profitability} %</td> 
        <td style={{ width: "200px"}}>{(((element.TotalValueTokenPrice*element.profitability)/100)*(Number(element.lock_in_period_no)/12)).toFixed(2)} €</td> 
        <td style={{ width: "200px"}}>{element.lock_in_period_no+" "+element.lock_in_period}</td> 
        <td style={{ width: "200px"}}>{(element.pct_id > 627 && element.property_id == 6) ? "02-11-2026" : element.property_id == 7 ? "13-04-2027" : (element.expiry_date?new Date(element.expiry_date).toLocaleDateString('en-GB', { timeZone: 'Asia/Kolkata' }).split('/').join('-'):"-")}</td> 
        <td style={{ width: "130px"}}>{element.isExpired ? <Link to={`/property-claim-fund/`+ btoa(element.property_id)} >{i18next.t('Claim')}</Link> : '-'}</td>
      </tr>
    ));

    setAllProperyInvestment(tempTBody);
  }

  const handleLoadGetPropertyCryptoTransactionData = async () => {
    const res = await getRequest('get-property-crypto-transaction-data');
    if (res && res.code === 200) {
      handleT1Body(res.data.transaction);
      setFilePath(res.data.url);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="7" className="text-center">{i18next.t('No records found')}</td>
                      </tr>);

      setTransactionTBody(tempTBody);
    }
  }

  const handleReferralLinkCopied = () => {
    setAlertData({
      variant: 'success',
      message: i18next.t('Link copied!'),
    });
    resetAlertData();
  };

  const [ currency, setcurrency ] = React.useState('Euro');

  const [euroBalanceData, setEuroBalanceData] = React.useState(0);
  const [usdtBalanceData, setUsdtBalanceData] = React.useState(0);
  const [CryptoData, setCryptoData] = React.useState([]);
  const handleLoadGetCryptoData = async () => {
    const res = await getRequest('get-crypto-data');
    if (res && res.code === 200) {
      setCryptoData(res.data);
      handleLoadGetPropertyInvestment(res.data);
    }
    else {
      // setAlertData((AlertData) => ({
      //   ...AlertData,
      //   variant: 'error',
      //   message: res.message,
      // }));
    }
    // resetAlertData();
  }

  const handleLoadGetPropertyInvestment = async (balance) => {
    const res = await getRequest('get-property-investment');
    if (res && res.code === 200) {

      let filteredCryptoTransaction = res.data.crypto_transaction.filter(transaction => transaction.is_claimed !== 1);

      const groupedTransactions = {};
      filteredCryptoTransaction.forEach(transaction => {
          const { property_id } = transaction;
      
          if (!groupedTransactions[property_id]) {
              groupedTransactions[property_id] = { transactions: [] };
          }
          groupedTransactions[property_id].transactions.push(transaction);
      });
      const propertiestransactions = Object.values(groupedTransactions);
      let AllPropertiesInvestment = []
      propertiestransactions.forEach(element => {
        let TotalValue = element.transactions.reduce((sum, transaction) => sum + parseFloat(transaction.value), 0);
        let TotalValueTokenPrice = element.transactions.reduce((sum, transaction) => {
            return sum + (parseFloat(transaction.value) * (parseFloat(transaction.token_price) || 0));
        }, 0);
        const isExpired = moment().isAfter(moment(element.transactions[0].expiry_date));
        AllPropertiesInvestment.push({
          property_id:  element.transactions[0].property_id,
          property_name: element.transactions[0].property_name,
          property_token_symbol: element.transactions[0].property_token_symbol,
          profitability: element.transactions[0].profitability,
          lock_in_period_no: element.transactions[0].lock_in_period_no,
          lock_in_period: element.transactions[0].lock_in_period,
          expiry_date: element.transactions[0].expiry_date,
          pct_id: element.transactions[0].pct_id,
          TotalValue: TotalValue,
          TotalValueTokenPrice: TotalValueTokenPrice,
          isExpired: isExpired
        })
      });

      handlePropertyInvestmentBody(AllPropertiesInvestment);


      balance.euro_available_balance = Number(balance.euro_available_balance) + res.data.total_value_token_price;

      const binanceDataRates = await handleLoadGetBinanceRates();
      const EuroToUsdtRate = binanceDataRates.find(item => item.symbol === 'EUR' + 'USDT');
      const UsdtToEuroRate = 1 / parseFloat(EuroToUsdtRate.price);
      let usdt_Available_Balance= Number(balance.usdt_available_balance) + (Number(balance.euro_available_balance) * parseFloat(EuroToUsdtRate.price))
      let euro_Available_Balance = Number(balance.euro_available_balance) + (Number(balance.usdt_available_balance) * parseFloat(UsdtToEuroRate))
      setEuroBalanceData(euro_Available_Balance);
      setUsdtBalanceData(usdt_Available_Balance)
    }
    else {
      balance.euro_available_balance = Number(balance.euro_available_balance);

      const binanceDataRates = await handleLoadGetBinanceRates();
      const EuroToUsdtRate = binanceDataRates.find(item => item.symbol === 'EUR' + 'USDT');
      const UsdtToEuroRate = 1 / parseFloat(EuroToUsdtRate.price);
      let usdt_Available_Balance= Number(balance.usdt_available_balance) + (Number(balance.euro_available_balance) * parseFloat(EuroToUsdtRate.price))
      let euro_Available_Balance = Number(balance.euro_available_balance) + (Number(balance.usdt_available_balance) * parseFloat(UsdtToEuroRate))
      setEuroBalanceData(euro_Available_Balance);
      setUsdtBalanceData(usdt_Available_Balance);

      // setAlertData((AlertData) => ({
      //   ...AlertData,
      //   variant: 'error',
      //   message: res.message,
      // }));
    }
    // resetAlertData();
  }     

  const baseData = [0, 15, 20, 22, 30, 40, 50, 60, 70, 80, 100];
  const euro_scaleFactor = Number(euroBalanceData) / 10000;
  const usdt_scaleFactor = Number(usdtBalanceData) / 10000;

  const euro_series = [
    {
      data: baseData.map(value => Math.round(value * euro_scaleFactor) || 1),
    },
  ];

  const usdt_series = [
    {
      data: baseData.map(value => Math.round(value * usdt_scaleFactor) || 1),
    },
  ];               
  const balance = [ { euro: Number.isInteger((Number(euroBalanceData))) ? (Number(euroBalanceData)) : (Number(euroBalanceData)).toFixed(2), usdt: Number.isInteger((Number(usdtBalanceData))) ? (Number(usdtBalanceData)) : (Number(usdtBalanceData)).toFixed(2), euro_series: euro_series, usdt_series: usdt_series, options: options1, } ]

  const handleLoadGetBinanceRates = async () => {
    const res = await getRequestForBinance();
    if (res && res.code === 200) {
      return(res.data);
    }
  }
  

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const openModal = (content) => {
    closeFirstModal()
    setModalContent(content);
    setShowModal(true);
  };

  const closeModal = () => {
    setModalContent("");
    setShowModal(false);
  };

  const [showFirstModal, setFirstShowModal] = useState(false);
  const [modalFirstContent, setModalFirstContent] = useState("");

  const openFirstModal = (content) => {
    setModalFirstContent(content);
    setFirstShowModal(true);
  };

  const closeFirstModal = () => {
    setModalFirstContent("");
    setFirstShowModal(false);
  };

  const renderFirstModalContent = () => {
    if (modalFirstContent === "before-investing") {
      return (
        <>
          <div className="referal-title" onClick={() => openModal("kyc-process")}>
            <h4 className="card-title">1. {i18next.t('KYC Process')}</h4>
          </div>
          <div className="referal-title mt-3" onClick={() => openModal("google-authenticator")}>
            <h4 className="card-title">2. {i18next.t('Google Authenticator')}</h4>
          </div>
        </>
      );
    }
    if (modalFirstContent === "how-to-invest") {
      return (
        <>
          <div className="referal-title" onClick={() => openModal("bank-transfer")}>
            <h4 className="card-title">1. {i18next.t('Bank Transfer')}</h4>
          </div>
          <div className="referal-title mt-3" onClick={() => openModal("cryptocurrencies")}>
            <h4 className="card-title">2. {i18next.t('Cryptocurrencies')}</h4>
          </div>
        </>
      );
    }
    return null;
  };

  const renderModalContent = () => {
    if (modalContent === "kyc-process") {
      return (
        <>
          <div className="referal-title mb-3">
            <h4 className="card-title">{i18next.t('KYC Process')}</h4>
          </div>
          <iframe
            src="https://scribehow.com/embed/Como_completar_la_Verificacion_KYC__0VfQmvFqQ9uZSdIQS63TyQ?removeLogo=true&as=video"
            width="100%"
            height="640"
            allowFullScreen
            frameBorder="0"
          ></iframe>
        </>
      );
    }
    if (modalContent === "google-authenticator") {
      return (
        <>
          <div className="referal-title mb-3">
            <h4 className="card-title">{i18next.t('Google Authenticator')}</h4>
          </div>
          <iframe
            src="https://scribehow.com/embed/Activar_Google_Authenticator__etchUNnXRWGd-ukBBSfDhw?removeLogo=true&as=video"
            width="100%"
            height="640"
            allowFullScreen
            frameBorder="0"
          ></iframe>
        </>
      );
    }
    if (modalContent === "bank-transfer") {
      return (
        <>
          <div className="referal-title mb-3">
            <h4 className="card-title">{i18next.t('Bank Transfer')}</h4>
          </div>
          <iframe
            src="https://scribehow.com/embed/Invertir_por_Transferencia_Bancaria__Grd2ji8FS3mb9-jH6ZknDA?removeLogo=true&as=video"
            width="100%"
            height="640"
            allowFullScreen
            frameBorder="0"
          ></iframe>
        </>
      );
    }    
    if (modalContent === "cryptocurrencies") {
      return (
        <>
          <div className="referal-title mb-3">
            <h4 className="card-title">{i18next.t('Cryptocurrencies')}</h4>
          </div>
          <iframe
            src="https://scribehow.com/embed/Invertir_con_Criptomonedas___puQl1RnQZuLQTUSwMHX0g?removeLogo=true&as=video"
            width="100%"
            height="640"
            allowFullScreen
            frameBorder="0"
          ></iframe>
        </>
      );
    }
    return null;
  };

  const [onLoadModalOpen, setOnLoadModalOpen] = useState(false);
  const closeOnLoadModal = () => {
    localStorage.setItem("open_project_popup", "false");
    setOnLoadModalOpen(false);
  };

  const investModal = () => {
    localStorage.setItem("open_project_popup", "false");
    history.push("/properties")  
  };

  const [openProjectName, setOpenProjectName] = useState();
  const handleLoadGetProperties = async () => {
    const res = await getRequest('get-properties');
    if (res && res.code === 200) {
      let originalText = res.data.data;
      let imageurl = res.data.url;

      let openProperties= [];

      await originalText.forEach(element => {
        if(element.token_investment < element.total_token && element.property_status !== "funded") {
          openProperties.push(element);
        }
      });

      if (openProperties.length > 0) {
        let PropertyName= localStorage.getItem("I18N_LANGUAGE") === "eng" ? openProperties[openProperties.length - 1].property_name : openProperties[openProperties.length - 1].translated_property_name;
        setOpenProjectName(PropertyName);
        const newImageUrl = `${process.env.REACT_APP_API_URL}${imageurl}${openProperties[openProperties.length - 1].cover_image}`
        setTimeout(() => {
          const modalElement = document.querySelector(".modal-left");
          if (modalElement) {
              modalElement.style.backgroundImage = `
                linear-gradient(rgba(3,107,65,0.6), rgba(3,107,65,0.6)),
                url("${newImageUrl}")
              `;
          }
        }, 1000)

        if(localStorage.getItem("open_project_popup")=="true"){
          setOnLoadModalOpen(true);
        }
      } else {
        setOnLoadModalOpen(false);
      }
      
    }
    else {
      setOnLoadModalOpen(false);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  React.useEffect(() => {
    handleLoadGetUserInfo();
    handleLoadGetProperties();
    handleLoadGetCryptoData();
    handleLoadGetPropertyCryptoTransactionData();

    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
		}
  }, []);

  // Balance Composition Data
const balanceComposition = [
  Number((CryptoData.total_dividend - CryptoData.used_dividend) - (CryptoData.total_claimed - CryptoData.used_claimed)) || 0,
  Number(CryptoData.welcome_bonus - CryptoData.used_welcome_bonus) || 0,
  Number(CryptoData.referral_bonus - CryptoData.used_referral_bonus) || 0,
  Number(CryptoData.early_bird_bonus - CryptoData.used_early_bird_bonus) || 0,
];

const totalBalance = balanceComposition.reduce((a, b) => a + b, 0);

// Donut Chart Options
const balanceOptions = {
  chart: { type: "donut" },
  labels: [
    "Dividends & Claims",
    "Welcome Bonus",
    "Referral Bonus",
    "Early Bird Bonus"
  ],
  colors: ["#0d6b4d", "#c8a35f", "#8e7cc3", "#d98c2b"],
  legend: { position: "right" },
};

// Add this near your other state declarations
const [earningsIndex, setEarningsIndex] = useState(0);
const projectsPerPage = 3;

const propertyData = Array.isArray(CryptoData.property_wise_investment)
  ? CryptoData.property_wise_investment
  : [];

// SLICE DATA FOR PAGINATION
const visibleProjects = propertyData.slice(earningsIndex, earningsIndex + projectsPerPage);

// X-axis (Project Names - short version)
const categories = visibleProjects.map(p => {
  // optional: shorten name like ECO1, ATG1 etc.
  return p.token_symbol.length > 12
    ? p.token_symbol.substring(0, 10) + "..."
    : p.token_symbol;
});

// Series Data
const principalClaimed = visibleProjects.map(p => Number(p.claim_total) || 0);
const dividends = visibleProjects.map(p => Number(p.dividend_total) || 0);

const nextEarnings = () => {
  if (earningsIndex + projectsPerPage < propertyData.length) {
    setEarningsIndex(earningsIndex + 1);
  }
};

const prevEarnings = () => {
  if (earningsIndex > 0) {
    setEarningsIndex(earningsIndex - 1);
  }
};

// Final Series
const earningsSeries = [
  {
    name: "Principal Claimed",
    data: principalClaimed,
  },
  {
    name: "Dividends",
    data: dividends,
  },
];

// Chart Options
const earningsOptions = {
  chart: {
    type: "bar",
    toolbar: { show: false },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "35%",
      borderRadius: 6,
    },
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: categories,
  },
  yaxis: {
    labels: {
      formatter: val => `€${val}`,
    },
  },
  tooltip: {
    y: {
      formatter: val => `€${val}`,
    },
  },
  colors: ["#0b3d2e", "#3bb273"],
  legend: {
    position: "top",
    horizontalAlign: "right",
  },
};

  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content common-width">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={i18next.t('PG title Tokenizedgreen')} breadcrumbItem={i18next.t('PG breadcrumbItem Dashboard')} />
          <Row>
            <Col xs="12">
              <div className="sidebar">
                <ul>
                  <li><Link to="/dashboard" className="active"><i className="bx bx-home-circle"></i> {i18next.t('Menu Dashboard')}</Link></li>
                  {
                    localStorage.getItem("Collaborator")=="true"?
                    <li><Link to="/collaborator"><i className="fas fa-handshake"></i> {i18next.t('Collaborator')}</Link></li>
                    :''
                  }
                  <li><Link to="/wallet"><i className="bx bx-wallet-alt"></i> {i18next.t('Menu My Wallet')}</Link></li>
                  <li><Link to="/properties"><i className="bx bx-shopping-bag"></i> {i18next.t('Menu Browse Property')}</Link></li>
                  <li><Link to="/portfolio"><i className="bx bx-cart-alt"></i> {i18next.t('Menu My Portfolio')}</Link></li>
                  <li><Link to="/claimed-fund"><i className="bx bx-money"></i> {i18next.t('Menu My Claimed Fund')}</Link></li>
                  <li><Link to="/mytransaction"><i className="bx bx-list-ul"></i> {i18next.t('Menu My Transaction')}</Link></li>
                  <li><Link to="/Kyc"><i className="bx bx-user-check"></i> {i18next.t('Menu KYC Verification')}</Link></li>
                  <li><Link to="/twofaauthenticator"><i className="bx bx-key"></i> {i18next.t('Menu 2FA Authenticator')}</Link></li>
                  <li><Link to="/dividends"><i className="bx bx-wallet-alt"></i> {i18next.t('Menu Dividends')}</Link></li>
                </ul>
              </div>
              <div className="contentt">
                  {/* <div className="christmas-offer">
                    <Typography variant="h5">{i18next.t('This Christmas,')}<br /><strong style={{ color: '#036B41' }}>{i18next.t('highlight')}</strong>{i18next.t('give the gift of sustainability')}</Typography>
                    
                    <div className={`christmas-button${localStorage.getItem("I18N_LANGUAGE") === "sp" ? " spanish" : ""}`}> 
                      <button type="button" className="btn btn-primary" onClick={() => setRedeemModal(true)}>{i18next.t('Reedem a Gift Card')}</button>
                      <button type="button"  className="btn btn-primary" onClick={() => { window.open('https://tokenizedgreen.es/tarjeta-de-regalo', '_blank'); }}>{i18next.t('Get a Gift Card')}</button>
                          <Modal centered backdrop="static" isOpen={redeemModal} toggle={() => setRedeemModal(!redeemModal)}>
                            <div className="modal-header">
                              <h5 className="modal-title mt-0">{i18next.t('Redeem Gift Card')}</h5>
                              <button type="button" onClick={() => setRedeemModal(false)} className="close" data-dismiss="modal" aria-label="Close" >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div className="modal-body">
                              <Row>
                                <Col xs="12">
                                  <div className="mb-3">
                                    <Label className="form-label">{i18next.t('Enter Gift Card Code')} :</Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="gift_card_code"
                                      placeholder={i18next.t('Enter Gift Card Code')}
                                      onChange={e => {
                                        setGiftCardCode(e.target.value);
                                        setGiftCardTouched(false);
                                      }}
                                      onBlur={() => setGiftCardTouched(true)}
                                      value={giftCardCode || ""}
                                      invalid={giftCardTouched && !giftCardCode}
                                      disabled={redeemLoading}
                                      autoComplete="off"
                                    />
                                    {giftCardTouched && !giftCardCode ? (
                                      <FormFeedback type="invalid">{i18next.t('Gift Card Code is required')}</FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                              </Row>
                            </div>
                            <div className="modal-footer">
                              <button type="button" className="btn btn-primary"
                                onClick={() => {
                                  setGiftCardTouched(true);
                                  if (giftCardCode) handleRedeemGiftCard();
                                }}
                              >{redeemLoading ? i18next.t('Processing...') : i18next.t('Redeem')}</button>
                              <button type="button" className="btn btn-light" data-dismiss="modal" onClick={() => setRedeemModal(false)}>{i18next.t('Close')}</button>
                            </div>
                          </Modal>
                    </div>
                    <div className="christmas-image"><img src={christmastree} alt="Christmas Tree" /></div>
                  </div>
                */}
                <Row>
                  <Col xs="12">
                    <Row>

                    <Col className="balaceBox">
                      <USDT reports={balance} />
                    </Col>
                    
                  <Col lg="12">
                    <div className="card">
                      <div className="card-body">
                        <div className="mb-3 h4 card-title">{i18next.t('Portfolio')}</div>
                        <div className="table-responsive">
                          <table className="table mb-0"  style={{ minWidth: '940px' }}>
                            <thead className="table-light">
                              <tr>
                                <th>{i18next.t('Token name')}</th>
                                <th style={{ width: "250px", textAlign: "center"}}>{i18next.t('Tokens')}</th>
                                <th style={{ width: "260px"}}>{i18next.t('Value')}</th>
                                <th style={{ width: "130px"}}>{i18next.t('Profitability')}</th>
                                <th style={{ width: "130px"}}>{i18next.t('Earnings')}</th>
                                <th style={{ width: "130px"}}>{i18next.t('Term')}</th>
                                <th style={{ width: "130px"}}>{i18next.t('ExpiryDate')}</th>
                                <th style={{ width: "130px", textAlign: "center"}}>{i18next.t('Action')}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allProperyInvestment}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Row>
                  <Col xs="12">
                    <Row>
                      <Col xl="12" md="12">
                        <div className="card">
                          <div className="card-body">
                            <div className="referal-title" onClick={() => openFirstModal("before-investing")}>
                              <h4 className="card-title">{i18next.t('What do I need to do before investing?')}</h4>
                            </div>
                            <div className="referal-title mt-3" onClick={() => openFirstModal("how-to-invest")}>
                              <h4 className="card-title">{i18next.t('How to invest?')}</h4>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                      <Col xl="12" md="12">
                        <div className="card">
                          <div className="card-body">
                            <div className="mb-3 h4 card-title">{i18next.t('Dashboard PG Referral Link')}</div>
                            <div className="Referal">
                              <p>{ReferralLink}</p>
                              <CopyToClipboard text={ReferralLink} onCopy={handleReferralLinkCopied}>
                                <i className="bx bx-copy-alt"></i>
                              </CopyToClipboard>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>       
                <Row className="mt-4">
</Row>    

<Row className="mt-4">
  {/* Balance Composition */}
  {/* Balance Composition */}
<Col lg="6" className="mb-4">
  <div className="card h-100">
    <div className="card-body d-flex flex-column">
      <h4 className="card-title">{i18next.t('Balance Composition')}</h4>
      <p className="text-muted">
        {i18next.t('What makes up the current')} €{totalBalance.toFixed(2)} {i18next.t('in the wallet')}
      </p>

      {/* Increased chart height to 350 and adjusted column ratios */}
      <div className="d-flex align-items-center justify-content-center flex-grow-1">
        <div style={{ width: "55%" }}>
          <ReactApexChart
            options={{
              ...balanceOptions,
              legend: { show: false } // Hiding default legend to use our custom big text
            }}
            series={balanceComposition}
            type="donut"
            height={350} 
          />
        </div>

        {/* Using h5 and mb-3 classes to make text bigger and more spaced out */}
        <div style={{ width: "45%", paddingLeft: "30px" }}>
          <div className="mb-3">
            <h5 className="mb-1 fw-bold" style={{ color: "#0d6b4d" }}>€{balanceComposition[0]}</h5>
            <p className="text-muted mb-0">{i18next.t('Dividends & Claims')}</p>
          </div>
          <div className="mb-3">
            <h5 className="mb-1 fw-bold" style={{ color: "#c8a35f" }}>€{balanceComposition[1]}</h5>
            <p className="text-muted mb-0">{i18next.t('Welcome Bonus')}</p>
          </div>
          <div className="mb-3">
            <h5 className="mb-1 fw-bold" style={{ color: "#8e7cc3" }}>€{balanceComposition[2]}</h5>
            <p className="text-muted mb-0">{i18next.t('Referral Bonus')}</p>
          </div>
          <div className="mb-0">
            <h5 className="mb-1 fw-bold" style={{ color: "#d98c2b" }}>€{balanceComposition[3]}</h5>
            <p className="text-muted mb-0">{i18next.t('Early Bird Bonus')}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</Col>

  {/* Earnings by Project */}
<Col lg="6" className="mb-4">
  <div className="card h-100">
    <div className="card-body d-flex flex-column">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          <h4 className="card-title">Earnings by Project</h4>
          <p className="text-muted small mb-0">
            Capital claimed vs dividends received
          </p>
        </div>
        
        {/* Navigation Arrows */}
        {propertyData.length > projectsPerPage && (
          <div className="d-flex gap-2">
            <Button 
              color="light" 
              size="sm" 
              onClick={prevEarnings} 
              disabled={earningsIndex === 0}
              className="rounded-circle"
            >
              <i className="mdi mdi-chevron-left"></i>
            </Button>
            <Button 
              color="light" 
              size="sm" 
              onClick={nextEarnings} 
              disabled={earningsIndex + projectsPerPage >= propertyData.length}
              className="rounded-circle"
            >
              <i className="mdi mdi-chevron-right"></i>
            </Button>
          </div>
        )}
      </div>

      <div className="flex-grow-1">
          <ReactApexChart
            options={earningsOptions}
            series={earningsSeries}
            type="bar"
            height={300}
          />
      </div>
    </div>
  </div>
</Col>
</Row>

           <Row className="mt-4">
  <Col xs="12">
    <h4 className="mb-3">{i18next.t('Project Breakdown')}</h4>
    <Row>
      {CryptoData.property_wise_investment && CryptoData.property_wise_investment.map((project, index) => {
        // Calculations
        const invested = Number(project.total_invested) || 0;
        const claimed = Number(project.claim_total) || 0;
        const dividends = Number(project.dividend_total) || 0;
        
        // Principal Recovery %
        const recoveryPercent = invested > 0 ? Math.min((claimed / invested) * 100, 100) : 0;
        
        // Yield on Capital % (Dividends / Total Invested)
        const yieldPercent = invested > 0 ? ((dividends / invested) * 100).toFixed(2) : "0.00";

        // Filter projects where user has actually invested or received something
        if (invested === 0 && claimed === 0 && dividends === 0) return null;

        return (
          <Col lg="6" md="12" key={index} className="mb-4">
            <div className="card h-100 shadow-sm border-0" style={{ borderRadius: "15px" }}>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <h5 className="card-title mb-1 fw-bold text-truncate" style={{ maxWidth: "250px" }}>
                      {project.property_name} 
                      <span className="badge bg-light text-muted ms-2 fw-normal" style={{ fontSize: "10px" }}>
                        {project.token_symbol?.split('-')[1] || project.token_symbol}
                      </span>
                    </h5>
                    {/* Placeholder for project subtitle/location */}
                    <p className="text-muted small mb-0">Project details & location</p>
                  </div>
                  {recoveryPercent === 100 && (
                    <span className="badge rounded-pill" style={{ backgroundColor: "#f3f0e7", color: "#8b7e5e", fontSize: "10px", padding: "6px 12px" }}>
                      {i18next.t('FULLY CLAIMED')}
                    </span>
                  )}
                </div>

                <Row className="text-center mt-4">
                  <Col xs="4 border-end">
                    <p className="text-muted small text-uppercase mb-1">{i18next.t('Invested')}</p>
                    <h5 className="fw-bold mb-0">€{invested.toLocaleString()}</h5>
                  </Col>
                  <Col xs="4 border-end">
                    <p className="text-muted small text-uppercase mb-1">{i18next.t('Principal Claimed')}</p>
                    <h5 className="fw-bold mb-0">€{claimed.toLocaleString()}</h5>
                  </Col>
                  <Col xs="4">
                    <p className="text-muted small text-uppercase mb-1">{i18next.t('Dividends')}</p>
                    <h5 className="fw-bold mb-0 text-success">€{dividends.toLocaleString()}</h5>
                  </Col>
                </Row>

                <hr className="my-4" style={{ opacity: "0.1" }} />

                <div className="mt-3">
                  <div className="d-flex justify-content-between small mb-1">
                    <span className="text-muted">{i18next.t('Principal recovery')}</span>
                    <span className="fw-bold">{recoveryPercent.toFixed(0)}%</span>
                  </div>
                  <div className="progress mb-3" style={{ height: "6px", backgroundColor: "#f0f0f0" }}>
                    <div 
                      className="progress-bar" 
                      role="progressbar" 
                      style={{ width: `${recoveryPercent}%`, backgroundColor: "#036B41" }}
                    ></div>
                  </div>

                  <div className="d-flex justify-content-between small mb-1">
                    <span className="text-muted">{i18next.t('Yield on capital')}</span>
                    <span className="fw-bold text-primary">+{yieldPercent}%</span>
                  </div>
                  <div className="progress" style={{ height: "6px", backgroundColor: "#f0f0f0" }}>
                    <div 
                      className="progress-bar" 
                      role="progressbar" 
                      style={{ width: `${Math.min(parseFloat(yieldPercent) * 2, 100)}%`, backgroundColor: "#4a90e2" }} 
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        );
      })}
    </Row>
  </Col>
</Row>         

{/* <Row className="mt-4">
  <Col xs="12">
    <div className="card">
      <div className="card-body">
        <h4 className="card-title">{i18next.t('Withdrawal Traceability')}</h4>
        <p className="text-muted">
          {i18next.t('Each bank withdrawal broken down by originating project')}
        </p>

        <div className="table-responsive">
          <table className="table align-middle table-nowrap mb-0">
            <thead className="table-light">
              <tr>
                <th>{i18next.t('DATE')}</th>
                <th>{i18next.t('AMOUNT')}</th>
                <th>{i18next.t('SOURCE BREAKDOWN (PER PROJECT)')}</th>
              </tr>
            </thead>
            <tbody>
              {CryptoData.withdrawBreakdown && CryptoData.withdrawBreakdown.map((withdrawal, idx) => (
                <tr key={idx}>
                  <td>
                    <div className="font-size-13">
                      {moment(withdrawal.created_at).format('YYYY-MM-DD')}
                    </div>
                    <div className="text-muted font-size-12">
                      {moment(withdrawal.created_at).format('HH:mm')}
                    </div>
                  </td>
                  <td className="fw-bold">
                    €{Number(withdrawal.withdraw_amount).toFixed(2)}
                  </td>
                  <td style={{ minWidth: "300px" }}>
                    <div className="progress" style={{ height: "24px", borderRadius: "4px", backgroundColor: "#f0f0f0" }}>
                      {withdrawal.used && withdrawal.used.map((source, sIdx) => {
                        const widthPercent = (source.amount / withdrawal.withdraw_amount) * 100;
                        const colors = ["#036B41", "#4A90E2", "#8E7CC3", "#D98C2B"]; // Sequential colors
                        
                        return (
                          <div
                            key={sIdx}
                            className="progress-bar"
                            role="progressbar"
                            style={{ 
                              width: `${widthPercent}%`, 
                              backgroundColor: colors[sIdx % colors.length],
                              fontSize: "10px",
                              lineHeight: "24px",
                              fontWeight: "bold"
                            }}
                            title={`${source.propert_name}: €${source.amount}`}
                          >
                            {widthPercent > 10 ? `${source.token_symbol?.split('-')[1] || 'PJ'} €${source.amount}` : ""}
                          </div>
                        );
                      })}
                    </div>
                  </td>
                  
                </tr>
              ))}
              {(!CryptoData.withdrawBreakdown || CryptoData.withdrawBreakdown.length === 0) && (
                <tr>
                  <td colSpan="4" className="text-center text-muted py-4">
                    {i18next.t('No withdrawal records found')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Col>
</Row> */}
                <Row>
                  <Col lg="12">
                    <div className="card">
                      <div className="card-body">
                        <div className="mb-3 h4 card-title">{i18next.t('Latest Transaction')}</div>
                        <div className="table-responsive">
                          <table className="table mb-0" style={{ minWidth: '1200px' }}>
                            <thead className="table-light">
                              <tr>
                                <th>{i18next.t('ID')}</th>
                                <th>{i18next.t('Tokens')}</th>
                                <th>{i18next.t('Currency')}</th>
                                <th>{i18next.t('Amount')}</th>
                                <th>{i18next.t('Date')}</th>
                                <th>{i18next.t('Status')}</th>
                                <th className="text-center">{i18next.t('Action')}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {TransactionTBody}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>


      <Modal isOpen={StandardModal1} backdrop={'static'} centered className="transation" >
        <div className="modal-header">
          <h5 className="modal-title mt-0">{i18next.t('Transaction Details')}</h5>
          <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p className="mb-3">{i18next.t('ID')} : <span className="text-primary">{Transaction.pct_id}	</span></p>
          <p className="mb-3">{i18next.t('Tokens')} : <span className="text-primary">{Transaction.token} </span></p>
          <p className="mb-3">{i18next.t('Currency')} : <span className="text-primary">{Transaction.currency} </span></p>
          <p className="mb-3">{i18next.t('Amount')} : <span className="text-primary">{parseFloat(Transaction.received_amount)} {Transaction.currency} {parseFloat(Transaction.used_euro_wallet_amount) !== 0? <b>( {Transaction.used_euro_wallet_amount} {i18next.t('My_Transaction PG EUR spent from euro wallet')} )</b> : '' }</span></p>
          <p className="mb-3">{i18next.t('Date')} : <span className="text-primary">{moment(Transaction.created_at).format('YYYY-MM-DD | HH:mm')}</span></p>
          <p className="mb-3">{i18next.t('Status')} : <span className={"font-size-14 badge bg-secondary rounded-pill " + (Transaction.status === 'Pending' ? 'badge-soft-warning' : Transaction.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{Transaction.status}</span></p>
          {Transaction.send_tx !== '' && Transaction.send_tx !== null?
          <p className="mb-3">{i18next.t('Transaction Hash')} : <span className="text-primary"><br />{Transaction.send_tx}</span></p>
          : '' }
          {Transaction.transaction_proof !== '' && Transaction.transaction_proof !== null?
          <p className="mb-3">{i18next.t('Transaction Proof')} : <span className="text-primary"><br /><a rel="noreferrer" target="_blank" href={`${process.env.REACT_APP_API_URL}${FilePath}${Transaction.transaction_proof}`} download={Transaction.transaction_proof}>{Transaction.transaction_proof}</a></span></p>
          : '' }
          {Transaction.transaction_information !== '' && Transaction.transaction_information !== null?
          <p className="mb-3">{i18next.t('Transaction Information')} : <span className="text-primary"><br />{Transaction.transaction_information}</span></p>
          : '' }
        </div>
      </Modal>
      
      <Modal isOpen={showFirstModal} centered toggle={closeFirstModal} className="transation" >
        <div className="modal-header">
          <button type="button" onClick={(e)=>setFirstShowModal(false)} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {renderFirstModalContent()}
        </div>
      </Modal>

      <Modal isOpen={showModal} centered toggle={closeModal} className="transation custom-modal">
        <div className="modal-header">
          <button type="button" onClick={(e)=>setShowModal(false)} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {renderModalContent()}
          </div>
      </Modal>

      <Modal isOpen={onLoadModalOpen} centered toggle={closeOnLoadModal} className="onLoadRegister">
        <div className="modal-full-width">
          <div className="modal-left">
            <p className="img-text">{openProjectName}</p>
          </div>
          <div className="modal-right">
            <div className="modal-header">
              <button type="button" onClick={closeOnLoadModal} className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
                <Typography className="onLoadRegistertitle">{i18next.t('Open Project')}</Typography>
                <Typography className="onLoadRegisterdes">{i18next.t('Would you like to invest in the project ?')}</Typography>
                    {/* <div className="mb-3 fullwidth">
                      <Input name="email" type="text" placeholder={i18next.t('Login PG Enter email')} />
                    </div>
                    <div className="mb-3 fullwidth">
                      <Input name="email" type="text" placeholder={i18next.t('Login PG Enter email')} />
                    </div>
                    <Link to="/properties" className="btn-sm btn btn-primary">{i18next.t('Invest')}</Link> */}
                <button type="button"  onClick={investModal} className="btn-sm btn btn-primary">{i18next.t('View Project')}</button>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
